export default __webpack_public_path__ + "static/media/fi4.456765e7.svg";